var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "overflow-auto" },
    [
      _vm._l(_vm.sendLists, function (item) {
        return _c("item", {
          key: item.id,
          attrs: { "send-list": item, isCurrent: _vm.isCurrent(item) },
          on: {
            select: _vm.onSelect,
            "quick-message": _vm.onSendQuickMessage,
            "email-message": (e) => _vm.$emit("email-message", e),
            edit: _vm.onEdit,
            delete: _vm.onDelete,
          },
        })
      }),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: {
            spinner: "waveDots",
            distance: 600,
            identifier: _vm.infiniteLoadKey,
          },
          on: { infinite: _vm.loadSendLists },
          scopedSlots: _vm._u([
            {
              key: "error",
              fn: function ({ trigger }) {
                return [
                  _c("h5", [
                    _c("span", { staticClass: "badge badge-danger" }, [
                      _vm._v(
                        "Whoops. It looks like the server is unavailable."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: {
                            click: function ($event) {
                              return trigger()
                            },
                          },
                        },
                        [_vm._v("Retry")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("span", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("template", { slot: "no-results" }, [
            _c("h5", [
              _c("span", { staticClass: "badge badge-secondary" }, [
                _vm._v("No results"),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }